const DyzioTheme = {
  platformName: 'Dyzio',
  headerLogo: {
    src: '/logo-white.png',
    alt: 'Dyzio Beta',
  },
  darkLogo: {
    src: '/dyzio-logo.png',
    alt: 'Dyzio Beta',
  },
  organisationId: 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96',
  isLightOnDark: true,
  shareSite: 'https://share.dyzio.co',
  title: 'dyzio',
  termsAndConditionsLink: 'https://dyzio.co/terms-of-use',
  influencerTermsAndConditionsLink: 'https://dyzio.co/terms-of-use',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
    },
    logoProps: {
      src: 'https://app.dyzio.co/dyzio-logo.png',
      floated: 'right',
      size: 'medium',
    },
  },
};

export default DyzioTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/dyzio.js
 **/